export default __webpack_public_path__ + "4a152f46ab55215470ad8097f12d9d8a.jpg";